import { NgClass } from '@angular/common';
import { Component, input, InputSignal, output } from '@angular/core';
import { ButtonVariation } from './button.enum';

@Component({
  selector: 'app-button',
  imports: [NgClass],
  templateUrl: './button.html',
})
export class Button {
  readonly text: InputSignal<string> = input<string>('');
  readonly variation: InputSignal<ButtonVariation> = input<ButtonVariation>('primary');
  readonly isDisable: InputSignal<boolean> = input<boolean>(false);

  clickedEvent = output<MouseEvent>();

  emitClickEvent($event: MouseEvent): void {
    this.clickedEvent.emit($event);
  }
}
